module.exports = __webpack_public_path__ + "static/media/gg-store.6b96e034.svg";